import { util } from 'echarts/core';
import { normalizeToArray } from '../../../util/utils';
import { type ThemeParser } from '../../../core/theme';
import darkDataZoomHandler from '../../../assets/mobileDarkDataZoomHandler.png';
import lightDataZoomHandler from '../../../assets/mobileLightDataZoomHandler.png';

const mobileSliderStyle = {
  light: {
    backgroundColor: '#F5F5F5',
    handleIcon: `image://${lightDataZoomHandler as string}`,
    areaColor: '#EDEDED'
  },
  dark: {
    backgroundColor: '#2B2B2B',
    handleIcon: `image://${darkDataZoomHandler as string}`,
    areaColor: '#333'
  }
};

export function parseDataZoom(
  option: Parameters<ThemeParser>[0],
  themeMode: 'light' | 'dark',
  sliderStyle: unknown
) {
  const optionDataZoom = normalizeToArray(option.dataZoom);
  const dataZoomInside = {
    type: 'inside',
    start: 0,
    end: 100,
    orient: 'horizontal'
  };
  const dataZoomSlider = {
    type: 'slider',
    bottom: 0,
    // 2022/09/27
    // 注释原因: datazoom经过设计（钱宇楠）讨论，暂时不需要组件单独在主题中配置拖动条左右边距，由业务方在页面上为图表渲染区域添加间距，以达到效果。
    // left: 12,
    // right: 18,
    height: '24px',
    fillerColor: 'rgba(51,102,255,0.08)',
    brushSelect: false
  };

  const defaultSliderStyle = {
    handleIcon: sliderStyle[themeMode].handleIcon,
    handleSize: 24,
    backgroundColor: sliderStyle[themeMode].backgroundColor,
    borderColor: 'transparent',
    left: 28,
    right: 28,
    dataBackground: {
      areaStyle: {
        color: sliderStyle[themeMode].areaColor,
        opacity: 1
      },
      lineStyle: {
        color: 'transparent'
      }
    },
    selectedDataBackground: {
      areaStyle: {
        color: 'rgba(51,102,255)',
        opacity: 0.16
      },
      lineStyle: {
        color: 'transparent'
      }
    },
    fillerColor: 'rgba(51, 102, 255, 0.08)',
    showDetail: false
  };

  // eslint-disable-next-line complexity
  optionDataZoom.forEach(item => {
    if (item.type === 'slider') {
      util.merge(item, dataZoomSlider);
      util.merge(item, defaultSliderStyle);
    } else {
      util.merge(item, dataZoomInside);
    }
  });
}

export function dataZoomThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  parseDataZoom(option, themeMode, mobileSliderStyle);
}
